<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-10">
          <v-skeleton-loader
            :loading="loading"
            type="table-heading, table-thead, table-row-divider@10, table-tfoot"
          >
            <v-card-actions>
              <v-row>
                <v-col
                  cols="4"
                  md="3"
                  xl="4"
                >
                  <v-toolbar
                    flat
                    dark
                  >
                    <v-toolbar-title class="md-4 white--text">
                      Company Status
                    </v-toolbar-title>
                  </v-toolbar>
                </v-col>
                <v-spacer />
                <v-col
                  cols="4"
                  md="3"
                  xl="4"
                >
                  <v-text-field
                    v-model="search"
                    placeholder="Search"
                    append-icon="fa fa-search"
                    label="Search Company"
                    hide-no-data
                    hide-selected
                    clearable
                  />
                </v-col>
              </v-row>
            </v-card-actions>
            <v-data-table
              :headers="headers"
              :items="companies"
              :items-per-page="10"
              :search="search"
              no-data-text="Oh no! NO company!!"
              no-results-text="Search properly can or not?!"
              item-key="company_uid"
              class="scrollable-table elevation-10"
              data-simplebar
            >
              <template v-slot:[`item.name`]="{ item }">
                <div>
                  <span>
                    {{ item.name }}
                  </span>
                </div>
              </template>
              <template v-slot:[`item.tax_list`]="{ item }">
                <div>
                  <span v-if="item.tax_list">
                    {{ item.tax_list }}
                  </span>
                  <span v-else>
                    No tax settings applied
                  </span>
                </div>
              </template>
              <template v-slot:[`item.is_excluded`]="{ item }">
                <div>
                  <v-icon
                    v-if="item.is_excluded"
                    medium
                    color="red"
                  >
                    mdi-window-close
                  </v-icon>
                  <v-icon
                    v-else
                    medium
                    color="green"
                  >
                    mdi-check
                  </v-icon>
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <company-dialog-edit
                  :company-id="item.id"
                  @updated="loadData"
                />
              </template>
            </v-data-table>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        companies: [],
        search: '',
        loading: true,
        headers: [
          { text: 'Company', align: 'left', value: 'name' },
          { text: 'Tax', align: 'left', value: 'tax_list' },
          { text: 'MSC Status', align: 'left', value: 'is_excluded' },
          { text: 'Action', align: 'left', value: 'action' },
        ],
      }
    },
    computed: {
    //   filteredCompanyQuota () {
    //     if (!this.companyId || !this.year) return
        
    //     return this.companyQuotas.filter(companyQuota => {
    //       return companyQuota.company_id === this.companyId && companyQuota.year === this.year
    //     })
    //   },
    },
    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.companies().list()
          .then(response => {
            this.companies = response.data

            // construct new property of object to store string of tax settings
            this.companies.map(company => {
              if (company.company_tax) { // only for tax setting exists for the company
                company.company_tax.map((companyTax) => {
                  if (companyTax.is_active) { // only active tax
                    if (!company.tax_list) { // first tax setting in string
                      company.tax_list = companyTax.tax_setting.name
                    } else { // next tax setting in string
                      company.tax_list += `, ${companyTax.tax_setting.name}`
                    }
                  }
                })
              }
            })

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>

</style>
